import { useContext } from 'react';
import { SummaryChartsDataContext } from '../contexts/SummaryChartsDataContext';

export const useSummaryChartsDataContext = () => {
    return useContext(SummaryChartsDataContext);
};
